module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="block">\n  <legend>Joinos Message</legend>\n\n  <table class="formtable">\n    <tr>\n      <td><label for="id_title">Title</label></td>\n      <td class="grid3">\n        <input class="textfield title" placeholder="Your message title"\n          id="id_title">\n      </td>\n    </tr>\n    <tr>\n      <td><label for="id_text">Text</label></td>\n      <td class="grid3">\n        <textarea class="textfield text" placeholder="Your message"\n          cols="140" rows="5" id="id_text"></textarea>\n      </td>\n    </tr>\n  </table>\n</fieldset>\n\n<fieldset class="block">\n  <legend>Attachments</legend>\n  <div class="attachment-hook"></div>\n</fieldset>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./messaging/templates/joinos.html
// module id = 283
// module chunks = 0